module.exports = __webpack_public_path__ + "e38124a9e838cbeb7d4a4d088eb0db07.svg";